const standardiseToLowerCase = input => input.replace(/\s/g, '_').toLowerCase();

export default standardiseToLowerCase;
